import CartAPI from "//www.riversol.com/cdn/shop/t/775/assets/script.cart.utility.js?v=159716337557705783961774982871";


const FREEPROMO_EVENT_BYPRODUCT = null;
const FREEPROMO_SELECTED_PRODUCTS = null;
const FREEPROMO_EVENT_TIERED = null;
const FREEPROMO_EVENT_SEGMENTED = null;
const FREEPROMO_EVENT = null;
const FREEPROMO_PRODUCTS = null;




async function updateCartNoteAttributes() {
    const currentCart = window.cart;
    if (!currentCart || !currentCart.items || !currentCart.items.length) return;

    let attributes = currentCart.attributes || {};
    let hasChanges = false;

    const firstVisit = localStorage.getItem('riversol_first_visit') || getCookie('riversol_first_visit');
    const landingUrlAttr = sessionStorage.getItem('riversol_landing_url') || '';
    const referringUrlAttr = sessionStorage.getItem('riversol_referring_url') || '';
    const quizCompleted = localStorage.getItem('quiz_completed');
    const quizStarted = localStorage.getItem('quiz_started');
    const quizAddedToCart = localStorage.getItem('quiz_added_to_cart');

    if (!attributes['First Visit']) {
        attributes['First Visit'] = firstVisit;
        hasChanges = true;
    }
    if (!attributes['Order Url']) {
        attributes['Order Url'] = decodeURIComponent(landingUrlAttr);
        hasChanges = true;
    }
    if (!attributes['Referring']) {
        attributes['Referring'] = decodeURIComponent(referringUrlAttr);
        hasChanges = true;
    }

    if (!attributes['Quiz Started'] && quizStarted === 'true') {
        attributes['quiz_action'] = 'started';
        hasChanges = true;
    }
    if (!attributes['Quiz Completed'] && quizCompleted === 'true') {
        attributes['quiz_action'] = 'completed';
        hasChanges = true;
    }
    if (!attributes['Quiz Added to Cart'] && quizAddedToCart === 'true') {
        attributes['quiz_action'] = 'added_to_cart';
        hasChanges = true;
    }

    if (hasChanges) {
        await CartAPI.setAttributes(attributes);
    }
}
  

  
// function getSmileTier() {
//     const smileTier = sessionStorage.getItem('smileTier') || Smile?.customer?.vip_tier_id;
//     const vip_tier = smileTier;
  
//     let tier;
//     if (vip_tier == "14543") {
//       tier = "Gold";
//     } else if (vip_tier == "14542") {
//       tier = "Silver";
//     } else {
//       tier = "Bronze";
//     }
  
//     if(tier)
//         sessionStorage.setItem('smileTier', vip_tier);
//         sessionStorage.setItem('smileTierName', tier);
  
//     return tier;
// }
  
// function loadingController(state) {
//     const ring = document.querySelector('.loading-ring');
  
//     switch (state) {
//       case 'on':
//         if (ring) ring.style.display = 'none';
//         document.querySelectorAll('input[name="checkout"]').forEach(el => {
//           el.disabled = true;
//         });
//         break;
  
//       case 'off':
//         if (ring) ring.style.display = '';
//         document.querySelectorAll('input[name="checkout"]').forEach(el => {
//           el.disabled = false;
//         });
//         break;
//     }
// }
  
  
  
// function updateCart() {
//     fetch(window.Shopify.routes.root + 'cart/update.js')
//         .then(response => response.json())
//         .then(data => { return data });
// }
  
// Requires a segment to add a free product to the cart
// Pass TRUE is you want to avoid this conditions
// const promoSegment = sessionStorage.getItem('freePromoSegment');
// let addToCartError = false;
// let cartRequestCompleted = true;

// const freeGiftByProductPromo = !!(FREEPROMO_EVENT_BYPRODUCT && FREEPROMO_SELECTED_PRODUCTS && FREEPROMO_SELECTED_PRODUCTS.length)
  
// function FreeProductPromoClass () {
    
//     this.initPromoEvent = initPromoEvent;
//     this.selectionAdd = selectionAdd;
//     this.selectionUpdate = selectionUpdate;
//     this.selectionChange = selectionChange;
//     this.eventCartCheck = eventCartCheck;
//     this.getMinTotal = getMinTotal;
//     this.removePromoItems = removePromoItems;
//     this.addPromoItem = addPromoItem;
//     this.swapPromoItem = swapPromoItem;
  
//     async function initPromoEvent() {
//         console.log('- INIT PROMO EVENT')
//         if(!(FREEPROMO_PRODUCTS && FREEPROMO_PRODUCTS.length)) return
  
//         loadingController('on');
//         freeProductPromo.selectionAdd();
//         freeProductPromo.eventCartCheck();
//     }
  
//     async function selectionAdd() {
//         console.log(' --- CHECK ADD PRODUCT ')
        
//         const cartItems = CartJS.cart.items;
//         const cartTotal = CartJS.cart.total_price / 100;
//         const allVariants = FREEPROMO_PRODUCTS.map(product => {
//             product.variants.forEach(v => v.tags = product.tags);
//             return product.variants
//         }).reduce((a,b) => a.concat(b));
  
//         if(cartTotal < this.getMinTotal()) {
//             await this.removePromoItems();
//             console.log(' === Cart does not have the minimum amount required');
//             return
//         }
  
//         if(!cartItems.length) {
//             console.log(' === Cart is empty');
//             return
//         }
            
//         // Validate if the free promo product is already include in the cart
//         if(cartItems.filter(item => item.properties._freePromoSelect).length) {
//             loadingController('off');
//             console.log(' === Free product is already included in the cart');
//             if(FREEPROMO_PRODUCTS.length > 1 ) {
//                 $('.freeProductSelect-wrapper').removeClass('d-none');
//             } 
//             return 
//         }
        
//         // Take the first product in the list to add - Except if it's a segmented event
//         const freeProductVariantToAdd = FREEPROMO_EVENT_SEGMENTED 
//                                     ? allVariants.filter(variant => variant.tags.join().indexOf(promoSegment) > -1)[0]
//                                     : allVariants[0];
  
        
//         // Skip if "addItem" got error (check error description in the console)
//         if(addToCartError) {
//             loadingController('off');
//             console.log(' === Error adding Free product to Cart');
//             return false
//         } 
            
//         // For "Gift by Product" promo, check if the product in the cart
//         if (freeGiftByProductPromo) {
//             const productInCart = cartItems.find(item => FREEPROMO_SELECTED_PRODUCTS.find(p => p.id === item.product_id))
//             if(!productInCart) {
//                 loadingController('off');
//                 console.log(' === (Gift by Product) Free product is already included in the cart');
//                 return;
//             }
//         }
   
//         // Add Promo item to cart
//         if(freeProductVariantToAdd) {
//             await this.addPromoItem(freeProductVariantToAdd.id);
//         };
        
//         return;
//     }
    
//     async function selectionUpdate() {
//         console.log(' --- CHECK UPDATE PRODUCT ')
//         const cartItems = CartJS.cart.items;
//         const cartTotal = CartJS.cart.total_price / 100;
        
  
//         // Check if cart total matches the minimum amount
//         if(cartTotal < this.getMinTotal()) {
//             await this.removePromoItems();
//             console.log(' === Cart does not have the minimum amount required');
//             return
//         } else {
  
//             // Check if "Segmented" promo is enabled/valid
//             if(FREEPROMO_EVENT_SEGMENTED && !promoSegment) {
//                 await this.removePromoItems();
//                 console.log(' === Segmented Promo is not enabled/valid');
//                 return
//             }
  
//             // Check if "Gift by Product" Promo is enabled/valid
//             if (freeGiftByProductPromo) {
//                 const productInCart = cartItems.find(item => FREEPROMO_SELECTED_PRODUCTS.find(p => p.id === item.product_id))
//                 if(!productInCart) {
//                     await this.removePromoItems();
//                     console.log(' === (Gift by Product) Free product is already included in the cart');
//                     return
//                 }
//             }
  
//             if(!cartItems.length) {
//                 console.log(' === Cart is empty');
//                 return
//             }
  
//             // Check if there are items to be added to cart
//             freeProductPromo.selectionAdd();
//         }
  
//     }
    
//     async function selectionChange(e) {
//         console.log(' --- CHANGING PRODUCT ')
//         const product = $(e).data('variant-id');
        
//         $('#modal-miniselect').modal('hide');
    
//         // await this.removePromoItems().catch(e => console.error(e));
//         // await this.addPromoItem(product);
//         const cartItems = CartJS.cart.items;
//         const removeItem = cartItems && cartItems.find(item => item.properties['_freePromoSelect']);
//         await this.swapPromoItem(removeItem.variant_id, product)
//     }
    
//     function eventCartCheck() {
//         console.log(' --- EVENT CHECK CART ')
  
//         const cartItems = CartJS.cart.items;
//         const cartTotal = CartJS.cart.total_price / 100;
//         // SUCCESS MESSAGE
//         if((promoSegment && (FREEPROMO_EVENT || FREEPROMO_EVENT_SEGMENTED || freeGiftByProductPromo || FREEPROMO_EVENT_TIERED)) && cartTotal > this.getMinTotal()) {
//             $('.cart-hero-wrapper-content *').hide();
//             $('.cart-hero-wrapper-content').append(`
//                 <span class="cart-hero-wrapper-content-success">${FREEPROMO_EVENT_SUCCESS_MSG}</span>
//             `)
//         }
//         else {
//             $('.cart-hero-wrapper-content *').show();
//             $('.cart-hero-wrapper-content-success').remove();
//         }
  
//         // Display segment products only
//         if(promoSegment) {
//             document.querySelectorAll(`.freepromo-${promoSegment}`).forEach(i => { i.classList.remove('d-none') });
//         } else {
            
//         }
//     }
  
//     function getMinTotal() {
//         let minTotal = FREEPROMO_EVENT_MIN_TOTAL;
//         if(FREEPROMO_EVENT_TIERED) {
//             switch(getSmileTier()) {
//                 case 'Bronze':
//                     minTotal = FREEPROMO_EVENT_MIN_TOTAL_BRONZE;
//                     break;
//                 case 'Silver':
//                     minTotal = FREEPROMO_EVENT_MIN_TOTAL_SILVER;
//                     break;
//                 case 'Gold':
//                     minTotal = FREEPROMO_EVENT_MIN_TOTAL_GOLD;
//                     break;
//             }
//         }
        
//         return minTotal
//     }
    
//     async function removePromoItems() {
//         console.log(' ------ REMOVING PRODUCT ');
//         loadingController('on');
        
//         cartRequestCompleted = false;
//         const cartItems = cart.items;
//         const removeItem = cartItems && cartItems.find(item => item.properties['_freePromoSelect']);
  
//         if(removeItem) {
//                 // TODO: FIX "COMPARE PRICE" WHEN REMOVING FREEPROMO ITEM
//                 //       COMPARE_PRICES_JSON.shift();
  
//                 return new Promise((resolve, reject) => {
//                     CartJS.removeItemById(removeItem.variant_id, {
//                         "success": function (data, textStatus, jqXHR) {
//                             cartRequestCompleted = true;
//                             console.log(' === Free Product REMOVED with success to the cart');
//                             loadingController('off');
//                             resolve(data);
//                         },
//                         "error": function(jqXHR, textStatus, errorThrown) {
//                             cartRequestCompleted = true;
//                             loadingController('off');
//                             reject(textStatus)
//                         }
//                     });
//                 })
//         } else {
//             cartRequestCompleted = true;
//             loadingController('off');
//         }
//     }
  
//     async function addPromoItem(productVariantId) {
//         console.log(' ------ ADDING PRODUCT ')
//         cartRequestCompleted = false;
//         loadingController('on');
  
//         return new Promise((resolve, reject) => {
//             CartJS.addItem(productVariantId, 1, { "_freePromoSelect": true }, {
//                 "success": function(data, textStatus, jqXHR) {
//                     console.log(' === Free Product ADDED with success to the cart');
//                     if(FREEPROMO_PRODUCTS.length > 1 ) {
//                         setTimeout(() => {
//                             $('.freeProductSelect-wrapper').removeClass('d-none');
//                         }, 2000)
//                     }    
//                     cartRequestCompleted = true;
//                     loadingController('off');
//                     resolve(data);
//                 },
//                 "error": function(jqXHR, textStatus, errorThrown) {
//                     jqXHR.responseJSON && console.log(`CartJS.addItem() Error: ${jqXHR.responseJSON.description}`)
//                     addToCartError = true;
//                     cartRequestCompleted = true;
//                     loadingController('off');
//                     reject(addToCartError);
//                 }
//             });
//         });
//     }
  
//     async function swapPromoItem(removeId, addId) {
//         console.log(' ------ SWAP PRODUCT ')
//         cartRequestCompleted = false;
//         loadingController('on');
  
//         return new Promise((resolve, reject) => {
//             CartJS.removeItemById(removeId, {
//                 "success": function (data, textStatus, jqXHR) {
//                     console.log(' === (Swap) Free Product REMOVED');
//                     CartJS.addItem(addId, 1, { "_freePromoSelect": true }, {
//                         "success": function(data, textStatus, jqXHR) {
//                             console.log(' === (Swap) Free Product ADDED'); 
//                             cartRequestCompleted = true;
//                             loadingController('off');
//                             resolve(data);
//                         },
//                         "error": function(jqXHR, textStatus, errorThrown) {
//                             jqXHR.responseJSON && console.log(`CartJS.addItem() Error: ${jqXHR.responseJSON.description}`)
//                             addToCartError = true;
//                             cartRequestCompleted = true;
//                             loadingController('off');
//                             reject(addToCartError);
//                         }
//                     });
//                 },
//                 "error": function(jqXHR, textStatus, errorThrown) {
//                     cartRequestCompleted = true;
//                     loadingController('off');
//                     reject(textStatus)
//                 }
//             });
//         })
//     }
  
// }
  
// const freeProductPromo = new FreeProductPromoClass();
  

let cartMetaSyncInFlight = null;
async function runCartMetaSync(source = 'unknown') {
    if (cartMetaSyncInFlight) return cartMetaSyncInFlight;

    cartMetaSyncInFlight = (async () => {
        try {
            window.cart = await CartAPI.init();
            await updateCartNoteAttributes();
            console.log('[cart-meta-sync] done:', source);
        } catch (err) {
            console.error('[script.cart.js] cart meta sync error:', err);
        } finally {
            cartMetaSyncInFlight = null;
        }
    })();

    return cartMetaSyncInFlight;
}

document.addEventListener('DOMContentLoaded', async () =>{
    try {
        // Run on full cart page load
        if (!/\/cart(?:\/|$)/.test(location.pathname)) return;

        await runCartMetaSync('cart-page-domcontentloaded');
        console.log('<<<<<<<<< CART LOADED >>>>>>>>>>');
        console.log(' - CART READY') ;
        // if(FREEPROMO_EVENT || (FREEPROMO_EVENT_SEGMENTED && promoSegment) || freeGiftByProductPromo || FREEPROMO_EVENT_TIERED) {
        //     if(FREEPROMO_EVENT_TIERED) {
        //         loadingController('on');
        //         let attempt = 1;
        //         const checkSmileLoop = function (millisec) {
        //             console.log('checkSmileLoop', attempt);
        //             if(window.hasOwnProperty('Smile') || sessionStorage.getItem('smileTier')) {
        //                 loadingController('off');
        //                 freeProductPromo.initPromoEvent();
        //             } else {
        //                 attempt ++;
        //                 setTimeout(() => {
        //                     checkSmileLoop(1000);
        //                 }, millisec)
        //             }
        //         }
        //         checkSmileLoop(1000);
        //     }
        //     else {
        //         freeProductPromo.initPromoEvent();
        //     }
            
        // }
        // else {
        //     freeProductPromo.removePromoItems();
        // }
        
    } catch (err) {
        console.error('[script.cart.js] DOMContentLoaded error:', err);
    }
});

// Run when cart drawer is opened (works outside /cart page too).
document.addEventListener('drawer:handleAfterShow', function(event) {
    const target = event && event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.tagName !== 'CART-DRAWER') return;
    runCartMetaSync('cart-drawer-open');
});

document.addEventListener('cart:updated', function() {
    runCartMetaSync('cart-updated');
});

  
// document.addEventListener('cart_event:updated', function(evt) {
    
//     // displayPointsOnCart();
  
//     // if(FREEPROMO_EVENT || FREEPROMO_EVENT_SEGMENTED || freeGiftByProductPromo || FREEPROMO_EVENT_TIERED) {
//     //     if(!cartRequestCompleted) return
        
//     //     loadingController('on');
//     //     setTimeout(() => {
//     //         freeProductPromo.selectionUpdate();
//     //         freeProductPromo.eventCartCheck();
//     //     }, 1000)
//     // }

//     console.log('CART UPDATED >>>>>>>>>>>>', evt.detail.cart);
// });
  


// SMILE ACTIONS

// const initSmileActions = () => {
//     getSmileTier();
//     displayPointsOnCart();
// }

// let checkSmileAttempt = 1;
// const checkSmile = function (millisec) {
//     // console.log('checkSmileLoop', checkSmileAttempt);
//     if(window.hasOwnProperty('Smile')) {
//         initSmileActions();
//     } else {
//         checkSmileAttempt ++;
//         setTimeout(() => {
//             checkSmile(500);
//         }, millisec)
//     }
// }
// checkSmile(1000);

// function displayPointsOnCart() {
//     const smileTierName = sessionStorage.getItem('smileTierName');

//     let pointsToEarn = 0;
//     const cartSubtotal = cart.items_subtotal_price/100;
//     switch(smileTierName) {
//         case 'Gold':
//             pointsToEarn = cartSubtotal * 5
//             // Promo points
//             // pointsToEarn = pointsToEarn + 50;
//             break;
//         case 'Silver':
//             pointsToEarn = cartSubtotal * 4
//             break;
//         default:
//             pointsToEarn = cartSubtotal * 2
//             break;
//     }
//     document.querySelectorAll('.smile-earning-points-wrapper').forEach(el => { el.classList.remove('d-none') });
//     document.querySelectorAll('.smile-earning-points').forEach(el => { el.innerHTML = pointsToEarn });
  
// }